@import "../config/_helpers";

.datepicker-section {
	.section-title {
		display: flex !important;
		align-items: center;
		justify-content: space-between;
		span {
			font-size: 12px;
			opacity: 0.5;
			@include at-breakpoint($l) {
				display: none;
			}
		}
	}
}

.date-selector {
	width: 100%;

	.looking-for-section {
		background: var(--accent-color);
		padding: 10px;
		color: white;
		border-radius: 5px;
		margin-bottom: 20px;
		cursor: pointer;
		display: none;
		@include at-breakpoint(0, $l) {
			display: block;
		}

		@include parent(".valentines") {
			background: #d92026;
		}
		@include parent(".mothers-day") {
			background: #f95c80;
		}
	}

	.date-options {
		display: flex;
		flex-wrap: wrap;
		align-items: stretch;
		justify-content: space-between;
		gap: 20px;
		@include at-breakpoint(0, $l) {
			gap: 10px;

			flex-wrap: nowrap;
			overflow-x: auto;
			scroll-snap-type: x mandatory;
		}
	}
	.datepicker {
		.datepicker-choice {
			display: flex;
			align-items: stretch;
			justify-content: space-between;
			gap: 20px;

			.change-choice {
				background: rgba(0, 0, 0, 0.1);
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				padding: 10px;
				border-radius: 5px;
				border: 2px solid rgba(0, 0, 0, 0.15);
				cursor: pointer;
				svg {
					font-size: 32px;
					margin-bottom: 10px;
				}
				&:hover {
					background: rgba(0, 0, 0, 0.15);
					border: 2px solid rgba(0, 0, 0, 0.2);
				}
			}

			.date-select {
				max-width: unset;
				flex: 1;
			}
		}
	}
	.date-select {
		flex: 1;
		border: 2px solid rgba(0, 0, 0, 0.15);
		border-radius: 5px;
		text-align: center;
		padding-top: 15px;
		line-height: 1;
		transition: 0.4s all ease-in-out;
		cursor: pointer;
		position: relative;
		scroll-snap-align: start;
		max-width: 110px;
		&:last-of-type {
			margin-right: auto;
		}

		&.Feb14 {
			--emphasis-color: #d1040d;
			border: 2px solid var(--emphasis-color);
			&:not(.active):hover {
				border: 2px solid var(--emphasis-color);
			}
			.callout {
				color: var(--emphasis-color);
			}
		}

		&.Dec24 {
			--emphasis-color: #d1040d;
			border: 2px solid var(--emphasis-color);
			&:not(.active):hover {
				border: 2px solid var(--emphasis-color);
			}
			.callout {
				color: var(--emphasis-color);
			}
		}

		&.Mar15 {
			--emphasis-color: #f95c80;
			border: 2px solid var(--emphasis-color);
			&:not(.active):hover {
				border: 2px solid var(--emphasis-color);
			}
			.callout {
				color: var(--emphasis-color);
			}
		}

		@include at-breakpoint(0, $l) {
			flex: 0 0 110px;
		}

		.day {
			opacity: 0.5;
			margin-bottom: 5px;
		}
		.date {
			font-size: 26px;
			font-weight: bold;
		}
		.month {
			font-size: 18px;
			font-weight: bold;
		}
		.delivery-cost {
			margin-top: 10px;
			font-size: small;
			opacity: 0.75;
		}
		.callout {
			font-size: smaller;
			font-weight: bold;
			background: rgba(0, 0, 0, 0.1);
			margin-top: 15px;
			padding: 5px 0;
			transition: 0.4s all ease-in-out;
			color: transparent;
		}

		.check {
			background: #0e4f31;
			border: #0e4f31;
			color: white;
			font-weight: bold;
			position: absolute;
			padding: 2px;
			aspect-ratio: 1/1;
			height: 24px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			top: -6px;
			right: -6px;
			opacity: 0;
			user-select: none;
			pointer-events: none;
			transition: 0.2s all ease-in-out;
			@include at-breakpoint(0, $l) {
				top: -2px;
				right: -2px;
			}
		}
		&.active {
			border-color: var(--emphasis-color);
			.callout {
				background: var(--emphasis-color);
				color: white;
			}
			.check {
				opacity: 1;
			}
		}
		&:not(.active):hover {
			border: 2px solid rgba(0, 0, 0, 0.2);
			.callout {
				background: rgba(0, 0, 0, 0.15);
			}
		}
	}
	.show-datepicker {
		font-weight: bold;
		margin: 15px 0;
		display: flex;
		color: var(--emphasis-color-dark-3);
		align-items: center;
		user-select: none;
		cursor: pointer;
		svg {
			margin-right: 5px;
			color: black;
			font-size: larger;
		}
		&:hover {
			text-decoration: underline;
		}
	}

	.delivery-options-container {
		.delivery-expected {
			font-size: larger;
			margin-top: 10px;
			display: block;
		}
	}

	@import "./datepicker.scss";
}
